/**
 * *************************************
 *  SHADAPPS CONFIDENTIAL
 *  __________________
 *
 *  Created by Vittorio Tauro
 *
 *  2022 (c) ShadApps Srl
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of ShadApps Srl and its suppliers,
 *  if any. The intellectual and technical concepts contained
 *  herein are proprietary to ShadApps Srl.
 *  and its suppliers and may be covered by Italian, European and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from ShadApps Srl.
 * *************************************
 * */

import { PATH_DASHBOARD } from '../../routes/paths';

const sectionsJson = {
    users: {
        pageTitle: 'Utenti',
        formTitle: 'Utente',
        btnCreate: 'Nuovo Utente',
        headerTitle: 'Lista Utenti',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'utenti', href: PATH_DASHBOARD.users.root },
        ],
    },
    airplanetypes: {
        pageTitle: 'Tipologia Aerei',
        formTitle: 'Tipologia Aereo',
        btnCreate: 'Nuovo Tipologia Aereo',
        headerTitle: 'Lista Tipologia Aerei',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        canDisable: true,

        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'aereo', href: PATH_DASHBOARD.airplanetypes.root },
        ],
    },
    companies: {
        pageTitle: 'Compagnia Aerea',
        formTitle: 'Compagnia Aerea',
        btnCreate: 'Nuovo Compagnia',
        headerTitle: 'Lista Compagnia Aerea',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,

        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'Compagnia', href: PATH_DASHBOARD.airplanetypes.root },
        ],
    },
    airports: {
        pageTitle: 'Aeroporti',
        formTitle: 'Aeroporto',
        btnCreate: 'Nuovo Aeroporto',
        headerTitle: 'Lista Aeroporti',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,

        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'aeroporto', href: PATH_DASHBOARD.airports.root },
        ],
    },
    airways: {
        pageTitle: 'Tratta',
        formTitle: 'Tratta',
        btnCreate: 'Nuovo Tratta',
        headerTitle: 'Lista Tratte',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'tratta', href: PATH_DASHBOARD.airways.root },
        ],
    },
    attributes: {
        pageTitle: 'Attributi aerei',
        formTitle: 'Attributo aereo',
        btnCreate: 'Nuovo Attributo',
        headerTitle: 'Lista Attributi aerei',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'utenti', href: PATH_DASHBOARD.attributes.root },
        ],
    },
    bookings: {
        pageTitle: 'Bookings',
        formTitle: 'Booking',
        btnCreate: 'Nuovo Utente',
        headerTitle: 'Lista Bookings',
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
        canExport: false,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'booking', href: PATH_DASHBOARD.bookings.root },
        ],
    },

    cms: {
        pageTitle: 'Cms',
        formTitle: 'CMS',
        btnCreate: 'Nuovo Cms',
        headerTitle: 'Lista Cms',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'cms', href: PATH_DASHBOARD.cms.root },
        ],
    },
    countries: {
        pageTitle: 'Paesi',
        formTitle: 'Paesi',
        btnCreate: 'Nuovo Paese',
        headerTitle: 'Lista Paesi',
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'paese', href: PATH_DASHBOARD.countries.root },
        ],
    },
    flights: {
        pageTitle: 'Voli',
        formTitle: 'Voli',
        btnCreate: 'Nuovo Volo',
        headerTitle: 'Lista Voli',
        canView: false,
        canCreate: 'flightCreateButton',
        // canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'volo', href: PATH_DASHBOARD.flights.root },
        ],
        actions: ['editFlight', 'copyFlight', 'showBookings'],
    },
    seats: {
        pageTitle: 'Posti',
        formTitle: 'Posti',
        btnCreate: 'Nuovo posto',
        headerTitle: 'Lista Posti',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'volo', href: PATH_DASHBOARD.flights.root },
        ],
    },
    passengers: {
        pageTitle: 'Passeggeri',
        formTitle: 'Passeggeri',
        btnCreate: 'Nuovo Passeggero',
        headerTitle: 'Lista Passeggeri',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'passeggero', href: PATH_DASHBOARD.passengers.root },
        ],
    },
    trips: {
        pageTitle: 'Voli acquistati/tando',
        formTitle: '',
        // btnCreate: 'Nuovo Caricamento',
        headerTitle: 'Voli acquistati/tando',
        canView: false,
        // canCreate: true,
        // canEdit: true,
        // canDelete: true,
        // canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'caricamento', href: PATH_DASHBOARD.uploads.root },
        ],
    },
    uploads: {
        pageTitle: 'Caricamenti',
        formTitle: 'Caricamenti',
        btnCreate: 'Nuovo Caricamento',
        headerTitle: 'Lista Caricamenti',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'caricamento', href: PATH_DASHBOARD.uploads.root },
        ],
    },
    tokens: {
        pageTitle: 'Token',
        formTitle: 'Token',
        btnCreate: 'Nuovo Caricamento',
        headerTitle: 'Lista Token',
        canView: false,
        canCreate: false,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'caricamento', href: PATH_DASHBOARD.uploads.root },
        ],
    },
    inviteCodes: {
        pageTitle: 'Invite code',
        formTitle: 'Invite code',
        headerTitle: 'Invite codes',
        btnCreate: 'Nuovo Invite code',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'invite codes', href: PATH_DASHBOARD.inviteCodes.root },
        ],
    },
    pricingPolicies: {
        pageTitle: 'Pricing policy',
        formTitle: 'Pricing policy',
        headerTitle: 'Pricing policies',
        btnCreate: 'Nuovo Pricing policy',
        canView: false,
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        textSearch: true,
        breadcrumbs: [
            { name: 'home', href: PATH_DASHBOARD.root },
            { name: 'Pricing Policy', href: PATH_DASHBOARD.inviteCodes.root },
        ],
    },
    // home: {}
};

export const allSections = Object.keys(sectionsJson); // filter out some keys if necessary.
export const entities = Object.keys(sectionsJson); // filter out some keys if necessary.
// ['users', 'crud']
export default sectionsJson;
